var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1344_123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 16.0007H12.6667V12.6387C12.6661 12.116 12.4583 11.6149 12.0887 11.2453C11.7191 10.8757 11.218 10.6678 10.6953 10.6673H5.30467C4.782 10.6678 4.28089 10.8757 3.91131 11.2453C3.54173 11.6149 3.33386 12.116 3.33333 12.6387V16.0007H2V12.6387C2.00106 11.7625 2.34957 10.9226 2.96908 10.3031C3.5886 9.68355 4.42854 9.33504 5.30467 9.33398H10.6953C11.5715 9.33504 12.4114 9.68355 13.0309 10.3031C13.6504 10.9226 13.9989 11.7625 14 12.6387V16.0007Z",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8C7.20888 8 6.43552 7.76541 5.77772 7.32588C5.11992 6.88636 4.60723 6.26164 4.30448 5.53074C4.00173 4.79983 3.92252 3.99557 4.07686 3.21964C4.2312 2.44372 4.61216 1.73098 5.17158 1.17157C5.73099 0.612165 6.44372 0.231202 7.21964 0.0768607C7.99557 -0.0774802 8.79983 0.00173314 9.53074 0.304484C10.2616 0.607234 10.8864 1.11992 11.3259 1.77772C11.7654 2.43552 12 3.20888 12 4C11.9989 5.06054 11.5772 6.07734 10.8273 6.82726C10.0773 7.57718 9.06054 7.99894 8 8ZM8 1.33334C7.47259 1.33334 6.95701 1.48973 6.51848 1.78275C6.07995 2.07577 5.73816 2.49224 5.53632 2.97951C5.33449 3.46678 5.28168 4.00296 5.38457 4.52024C5.48747 5.03753 5.74144 5.51268 6.11438 5.88562C6.48732 6.25856 6.96248 6.51254 7.47976 6.61543C7.99704 6.71832 8.53322 6.66552 9.02049 6.46368C9.50776 6.26185 9.92424 5.92005 10.2173 5.48152C10.5103 5.04299 10.6667 4.52742 10.6667 4C10.6667 3.29276 10.3857 2.61448 9.88562 2.11438C9.38552 1.61429 8.70725 1.33334 8 1.33334Z",
    fill: "#212529"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1344_123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownProfile);
export default __webpack_public_path__ + "static/media/dropdownProfile.097f170a23cd279970649f36105c3431.svg";
export { ForwardRef as ReactComponent };